import React, { useState } from "react";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-40">
      <nav className="container mx-auto flex justify-between items-center px-4 relative h-16">
        <div className="md:hidden flex justify-end w-full">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="text-gray-700 hover:text-primary rounded-lg p-2 transition duration-300"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16m-7 6h7"
              ></path>
            </svg>
          </button>
        </div>

        <ul
          className={`${
            isOpen
              ? "block z-50 bg-white w-full absolute top-16 left-0 p-4 space-y-4 shadow-lg rounded-b-lg border-t border-gray-200"
              : "hidden"
          } md:flex md:space-x-8 justify-center font-medium items-center md:w-full md:h-full`}
        >
          <li className="group relative flex items-center justify-center h-full px-4 md:px-0">
            <a
              href="/hakkimizda"
              className="text-gray-700 hover:text-primary transition duration-300 text-sm"
            >
              Hakkımızda
            </a>
            <span className="block h-0.5 bg-primary absolute bottom-0 left-0 w-0 group-hover:w-full transition-all duration-300"></span>
          </li>
          <li className="group relative flex items-center justify-center h-full px-4 md:px-0">
            <a
              href="/fotogaleri"
              className="text-gray-700 hover:text-primary transition duration-300 text-sm"
            >
              Galeri
            </a>
            <span className="block h-0.5 bg-primary absolute bottom-0 left-0 w-0 group-hover:w-full transition-all duration-300"></span>
          </li>
          <li className="group relative flex items-center justify-center h-full px-4 md:px-0">
            <a
              href="/iletisim"
              className="text-gray-700 hover:text-primary transition duration-300 text-sm"
            >
              İletişim
            </a>
            <span className="block h-0.5 bg-primary absolute bottom-0 left-0 w-0 group-hover:w-full transition-all duration-300"></span>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Navbar;
